import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { MatSort } from '@angular/material/sort';
import { finalize } from 'rxjs/operators';
import { LaravelResourceResponse } from '../../../../../../../../../_base-shared/contracts/laravel-response.interface';
import { Case } from '../../../../../../../../../_base-shared/models/Case/Case';
import { PaymentTerm } from '../../../../../../../../../_base-shared/models/Payment/PaymentTerm';
import { PaymentService } from '../../../../../payment/payment.service';
import { MatPaginator } from '@angular/material/paginator';

@Component({
  standalone: false,
  selector:    'app-case-installment-fees',
  templateUrl: './case-installment-fees.component.html',
  styleUrls:   ['./case-installment-fees.component.scss']
})
export class CaseInstallmentFeesComponent implements OnInit {
  @ViewChild(MatSort, {static: true}) sort: MatSort;
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @Input() componentType: 'distribution' | 'admin';
  @Input() case: Case;
  @Input() feeType: 'setup_fee' | 'management_fee' | 'negotiation_fee' | 'debt_plan_fee';
  public displayedColumnsChildInstallments: Array<string> = [];
  public dataSource: MatTableDataSource<PaymentTerm>;
  public isLoading                                        = 0;
  public now                                              = new Date(new Date().setHours(0, 0, 0, 0));
  public totalResults: number;
  public sortOrder                                        = 'asc';
  public sortBy                                           = 'term_date';
  public paginatorConfig                                  = {
    pageIndex: 0,
    pageSize:  10,
    length:    1,
  };

  constructor(private paymentService: PaymentService) {
  }

  ngOnInit(): void {
    this.displayedColumnsChildInstallments = this.getChildInstallmentsTableColumns();
    this.fetchInstallmentFees();
  }

  private fetchInstallmentFees(): void {
    const data      = {
      per_page:               this.paginatorConfig.pageSize,
      page:                   this.paginatorConfig.pageIndex + 1,
      case_id:                this.case.id,
      select_all:             0,
      order:                  this.sortOrder,
      sort_by:                this.sortBy,
      payment_plan_type_slug: this.feeType,
    };
    const relations = ['case_payment_plan.type', 'parent_installment'];
    this.dataSource = new MatTableDataSource<PaymentTerm>([]); //  Empty data source
    this.isLoading++;
    this.paymentService.getInstallmentFees(this.case.id, data, relations)
      .pipe(finalize(() => this.isLoading--))
      .subscribe(
        (result: LaravelResourceResponse<Array<PaymentTerm>>) => {
          this.dataSource             = new MatTableDataSource<PaymentTerm>(result.data);
          this.dataSource.paginator   = this.paginator;
          this.dataSource.sort        = this.sort;
          this.paginatorConfig.length = result.meta.total;
          this.totalResults           = result.meta.total;
          this.paginatorConfig.length = result.data.length;
        },
        err => console.error(err),
      );
  }

  private getChildInstallmentsTableColumns(): Array<string> {
    return [
      'name',
      'next-payment',
      'date-paid',
      'amount',
    ];
  }

  public getPercent(paid, amount) {
    if ((paid / amount) * 100) {
      return ((paid / amount) * 100).toFixed(2);
    } else {
      return 0;
    }
  }
}
